export default [
  { name: "ทั้งหมด", color: "#e8e8e8" },
  { name: "ยังไม่ได้ยื่นหลักฐานการชำระเงิน", color: "#303133" },
  { name: "รอตรวจสอบการชำระเงิน", color: "#f2711c" },
  { name: "ชำระเงินสำเร็จ", color: "#21ba45 " },
  { name: "ชำระเงินไม่สำเร็จ", color: "#db2828" },
];
